<template>
    <div>
        <template v-if="isPageAllowed">
            <div class="bg-color" style="padding-bottom: 10px;transition: none;">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" :before-leave="beforeChangeTab">
                        <el-tab-pane label="标签维护" name="tag_management_page" v-if="tabsList.includes('tag_management_page')"></el-tab-pane>
                        <el-tab-pane label="媒体" name="plat_management_page" v-if="tabsList.includes('plat_management_page')"></el-tab-pane>
                        <el-tab-pane label="集团" name="bloc_management_page" v-if="tabsList.includes('bloc_management_page')"></el-tab-pane>
                        <el-tab-pane label="客户" name="company_management_page" v-if="tabsList.includes('company_management_page')"></el-tab-pane>
                        <el-tab-pane label="代理" name="plat_username_page" v-if="tabsList.includes('plat_username_page')"></el-tab-pane>
                        <el-tab-pane label="账户" name="account_management_page" v-if="tabsList.includes('account_management_page')"></el-tab-pane>
                        <el-tab-pane label="计划" name="plan_management_page" v-if="tabsList.includes('plan_management_page')"></el-tab-pane>
                        <el-tab-pane label="产品" name="app_management_page" v-if="tabsList.includes('app_management_page')"></el-tab-pane>
                        <el-tab-pane label="项目" name="project_management_page" v-if="tabsList.includes('project_management_page')"></el-tab-pane>
                    </el-tabs>
                </div>
                <!--<component :ref="activeTabName" :is="activeTabName" :page-func-names="pageFuncNames" :page-fields="pageFields" />-->
                <tag_management_page ref="tabPage" v-if="activeTabName=='tag_management_page'" :page-func-names="pageFuncNames" :page-fields="pageFields"/>
                <ListPage ref="listPage" v-else :page-func-names="pageFuncNames" :page-fields="pageFields" :api-type="apiType" />

            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>页面无权限描述</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import { mapState,mapGetters } from 'vuex';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import ListPage from './page/list';
    import tag_management_page from './page/tag';

    export default {
        name: "TagManagementPage",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            ListPage,
            tag_management_page,
        },
        data(){
            return {
                isPageAllowed: true,
                activeTabName:'',
            }
        },
        computed:{
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
            }),
            ...mapGetters(['tabs_map']),
            tabsList() {
                let tagManagementTabs = this.tabs_map.tag_management || [];
                return tagManagementTabs.map(item => item.name);
            },
            apiType(){
                let apiMap = {
                    plat_management_page:'plat',
                    bloc_management_page:'bloc',
                    company_management_page:'company',
                    plat_username_page:'platusername',      // 代理
                    account_management_page:'account',
                    plan_management_page:'plan',
                    app_management_page:'subproject',
                    project_management_page:'project',
                };
                return apiMap[this.activeTabName]||'';
            },
        },
        created(){
            this.activeTabName = this.$route.name;
        },
        mounted(){

        },
        watch:{
            sidebarOpened(){
                setTimeout(()=>{
                    // this.calcTableHeight();
                },100)
            },
        },
        beforeDestroy(){
            window.removeEventListener("resize", this.calcTableHeight);
        },
        methods:{
            calcTableHeight(){
                // let $filterBar = document.querySelector('.filter-bar');
                // let filterBarHeight = $filterBar?$filterBar.clientHeight:0;
                // let height = window.innerHeight - 70 - filterBarHeight - 45 - 52 - 20;
                // this.$nextTick(()=>{
                //     this.tableHeight = height;
                // })
            },
            beforeChangeTab(newName){
                let routeData = this.$router.resolve({
                    name: newName,
                    query: this.$route.query,
                });
                this.activeTabName = newName;
                this.$router.push(this.activeTabName);
            },
            changePage(page){
                console.log('changePage',page);
            },
            initPageStates(){
                console.log(2,this.activeTabName)
                // let $tabPage = this.$refs[this.activeTabName];
                // if($tabPage&&$tabPage.initPageStates){
                //     $tabPage.initPageStates();
                // }

                let $tabPage = this.$refs.listPage;
                if($tabPage&&$tabPage.initPageStates){
                    $tabPage.initPageStates();
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bg-color {
        /*background-color: #f8f8f9;*/
    }

</style>
